module.exports = __webpack_public_path__ + "static/media/advisory-group-west.87fc87f9.png";